import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import AccountMarketingMaterialFlyerPrintTemplate from './AccountMarketingMaterialFlyerPrintTemplate/AccountMarketingMaterialFlyerPrintTemplate';
import { MARKETING_MATERIAL_TYPE } from '../../constants';
import AccountMarketingMaterialSocialPrintTemplate from './AccountMarketingMaterialSocialPrintTemplate/AccountMarketingMaterialSocialPrintTemplate';
import getAccountMarketingMaterial from '../../graphql/getAccountMarketingMaterial';
import AccountMarketingMaterialProfilePagePrintTemplate from './AccountMarketingMaterialProfilePagePrintTemplate';
import AccountMarketingMaterialWeddingFlyerTemplate from './AccountMarketingMaterialWeddingFlyerTemplate';
import AccountMarketingMaterialWeddingFlyerVideoGuestbookTemplate from './AccountMarketingMaterialWeddingFlyerVideoGuestbookTemplate';
import AccountMarketingMaterialWeddingTableTentTemplate from './AccountMarketingMaterialWeddingTableTentTemplate';
import AccountMarketingMaterialShutterbugFlyerTemplate from './AccountMarketingMaterialShutterbugFlyerTemplate';
import AccountMarketingMaterialShutterbugTableTentTemplate from './AccountMarketingMaterialShutterbugTableTentTemplate';
import AccountMarketingMaterialShareQR from './AccountMarketingMaterialShareQR';
import AccountMarketingMaterialEventFlyerTemplate from './AccountMarketingMaterialEventFlyerTemplate';
import AccountMarketingMaterialEventTableTentTemplate from './AccountMarketingMaterialEventTableTentTemplate';
import AccountMarketingMaterialBusinessCardPrintTemplate from './AccountmarketingMaterialBusinessCardTemplate/AccountMatketingMaterialBusinessCardTemplate';

const propTypes = {
  className: PropTypes.string,
};

const AccountMarketingMaterialPrintTemplate = ({ className }) => {
  const { accountMarketingMaterialId } = useParams();
  const { data: { accountMarketingMaterial } = {} } = useQuery(
    getAccountMarketingMaterial,
    {
      variables: {
        id: accountMarketingMaterialId,
      },
    },
  );

  const albumFolder = accountMarketingMaterial?.album_folder;
  const account = accountMarketingMaterial?.account;

  if (!accountMarketingMaterial) {
    return null;
  }

  const classes = classNames({
    'marketing-material-print-template': true,
    'onboarding-social': [MARKETING_MATERIAL_TYPE.ONBOARDING_SOCIAL].includes(
      accountMarketingMaterial?.type,
    ),
    landscape: [MARKETING_MATERIAL_TYPE.PROFILE_PAGE_SOCIAL].includes(
      accountMarketingMaterial?.type,
    ),
    [className]: !!className,
  });

  return (
    <div
      id={`account-marketing-material-${accountMarketingMaterialId}`}
      className={classes}
    >
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.ONBOARDING_FLYER && (
        <AccountMarketingMaterialFlyerPrintTemplate
          albumFolder={albumFolder}
          account={account}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.ONBOARDING_SOCIAL && (
        <AccountMarketingMaterialSocialPrintTemplate
          albumFolder={albumFolder}
          account={account}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.PROFILE_PAGE_SOCIAL && (
        <AccountMarketingMaterialProfilePagePrintTemplate
          albumFolder={albumFolder}
          account={account}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.BUSINESS_CARD && (
        <AccountMarketingMaterialBusinessCardPrintTemplate
          albumFolder={albumFolder}
          account={account}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.WEDDING_FLYER && (
        <AccountMarketingMaterialWeddingFlyerTemplate
          albumFolder={albumFolder}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.WEDDING_TABLE_TENT && (
        <AccountMarketingMaterialWeddingTableTentTemplate
          albumFolder={albumFolder}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.WEDDING_FLYER_VIDEO_GUESTBOOK && (
        <AccountMarketingMaterialWeddingFlyerVideoGuestbookTemplate
          albumFolder={albumFolder}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.SHUTTERBUG_FLYER && (
        <AccountMarketingMaterialShutterbugFlyerTemplate
          albumFolder={albumFolder}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.SHUTTERBUG_TABLE_TENT && (
        <AccountMarketingMaterialShutterbugTableTentTemplate
          albumFolder={albumFolder}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.QR_CODE_SHARE && (
        <AccountMarketingMaterialShareQR albumFolder={albumFolder} />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.EVENT_FLYER && (
        <AccountMarketingMaterialEventFlyerTemplate
          albumFolder={albumFolder}
          configuration={accountMarketingMaterial.configuration}
        />
      )}
      {accountMarketingMaterial.type ===
        MARKETING_MATERIAL_TYPE.EVENT_TABLE_TENT && (
        <AccountMarketingMaterialEventTableTentTemplate
          albumFolder={albumFolder}
        />
      )}
    </div>
  );
};

AccountMarketingMaterialPrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialPrintTemplate;
